import { createReducer, on } from '@ngrx/store';
import * as UserDeleteActions from '../actions/user-delete.actions';

export const userDeleteFeatureKey = 'userDelete';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UserDeleteActions.userDelete, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UserDeleteActions.userDeleteSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UserDeleteActions.userDeleteFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UserDeleteActions.clearUserDeleteState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
